module.exports = __webpack_public_path__ + "img/ownership.8f020b51.png";